import { useContext, useEffect, useRef, useState } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  CssBaseline,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { PageContext } from "../contexts/PageContext";
import { Robot } from "../models/Robot";
import { GroupAdd, RefreshRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { loadModel, loadOrgRecords } from "../api/connection";
import Minibar from "../components/Minibar";
import PageHeader from "../components/PageHeader";
import { SignalingConnection } from "../api/signaling/SignalingConnection";
import { createOrg } from "../models/Org";

export default function Robots() {
  const { isLoggedIn, user } = useContext(PageContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [filter, setFilter] = useState<string>("");
  const [filteredRows, setFilteredRows] = useState<Robot[]>([]);
  const hasRunLoader = useRef<boolean>(false);

  useEffect(() => {
    // console.log('Component mounted, isLoggedIn:', isLoggedIn);
    if (!isLoggedIn) {
      navigate("/");
      return;
    }

    // if (hasRunLoader.current) {
    //   return;
    // }

    // hasRunLoader.current = true;

    const fetchRobots = async () => {
      try {
        const res = await loadOrgRecords<Robot>("robots");
        const sortedRobots = res.sort((a, b) => a.name.localeCompare(b.name));
        for (const robot of sortedRobots) {
          robot.status = "";
          robot.version = "";
        }
        // await updateRobotStatus(sortedRobots);
        setFilteredRows(sortedRobots);
      } catch (err) {
        console.error("Failed to fetch robots:", err);
      } finally {
        setLoading(false);
      }
    };
    if (isLoggedIn && user) {
      fetchRobots();
    }
    // return () => {
    //   console.log('Component unmounted');
    // };
  }, [isLoggedIn, navigate, isLoggedIn, user]);

  const updateRobotStatus = async () => {
    const rs = filteredRows;
    const org = createOrg(user?.orgId);
    await loadModel(org);
    try {
      const sc = new SignalingConnection({
        deviceId: org._id,
        token: org.token,
        group: "techmage-query",
      });
      await sc.connect();
      const results = (await sc.sendQuery("OrgRobotStates")) as any[];
      console.log("results", results);
      sc.close();
      for (const robot of rs) {
        robot.status = "";
        robot.version = "";
        const robotResults = results.filter((r) => r._id === robot._id);
        for (const result of robotResults) {
          if (result.active && Date.now() - result.active < 10000) {
            robot.status += `${result.group}: ${result.robocoreVersion}`;
          }
          // robot.roboCoreVersion = result.robocoreVersion;
        }
      }
      setFilteredRows([...rs]);
    } catch (err) {
      console.error("Failed to fetch robot status:", err);
    }
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 0,
            m: 0,
            backgroundColor: "#212121",
            color: "#ECECEC",
            minHeight: "100vh",
          }}
        >
          <Backdrop
            open={loading}
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

          <PageHeader
            title={"Robots"}
            rightComponent={[
              <Minibar
                minibarItems={[
                  {
                    text: "Add Robot",
                    icon: <GroupAdd />,
                    nav: `/edit-robot/new`,
                  },
                  {
                    text: "Refresh",
                    icon: <RefreshRounded />,
                    onClick: updateRobotStatus,
                  },
                ]}
                barLength={2}
                // searchLabel="Search Robots"
                // onSearch={(e) => setFilter(e)}
              />,
            ]}
          />
          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left" width="20%">
                    Name
                  </TableCell>
                  <TableCell align="left" width="15%">
                    Type
                  </TableCell>
                  <TableCell align="left" width="25%">
                    Ethernet IP
                  </TableCell>
                  <TableCell align="left" width="40%">
                    Deployment Type
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRows.map((robot) => (
                  <TableRow hover key={robot._id}>
                    <TableCell align="left">
                      <Link
                        onClick={() => navigate(`/edit-robot/${robot._id}`)}
                        style={{ color: "#b0d1ff", cursor: "pointer" }}
                      >
                        {robot.name}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      {robot.type.charAt(0).toUpperCase() + robot.type.slice(1)}
                    </TableCell>
                    <TableCell align="left">
                      {robot.robotIP ? robot.robotIP : "N/A"}
                    </TableCell>
                    <TableCell align="left">
                      {robot.deploymentType ? robot.deploymentType : "N/A"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </>
  );
}
